import React from 'react';
import { graphql } from "gatsby";
import { makeStyles } from '@material-ui/styles';
import {buildBlocks} from "../../../services/builder";
import Grid from '@material-ui/core/Grid';
import styles from './styles';

const useStyles = makeStyles(theme => styles(theme));

export const CgbBrandLinkGridBlock = (props) => {
    const blocks = buildBlocks(props.innerBlocks, props.parentAttributes, props.pageContext);
    const classes = useStyles();

    return <div className={`brand-link-grid ${props.attributes.className ? props.attributes.className : ''} ${classes.brandLinkGrid} ${classes.brandLinkGridTheme}`}>
        <Grid container spacing={3} direction="row">
            <Grid item xs={12} md={8} lg={6} >
                {blocks[1]}
                {blocks[2]}
            </Grid>
            <Grid item xs={12} md={4} lg={6} >
                {props.attributes.hasButton === true &&
                    <>
                        {blocks[0]}
                    </>
                }
            </Grid>
            <Grid item xs={12} >
                <div className="brand-links">
                    {blocks[3]}
                    {blocks[4]}
                    {blocks[5]}
                    {blocks[6]}
                    {blocks[7]}
                    {blocks[8]}
                </div>
            </Grid>
        </Grid>
    </div>
};

export const CgbBrandLinkGridBlockFragment = graphql`
  fragment CgbBrandLinkGridBlock on WpBlock {
    ... on WpCgbBrandLinkGridBlock {
        name
        attributes {
            className
            hasButton
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbBrandLinkGridBlockPreview = `
    ... on CgbBrandLinkGridBlock {
        name
        attributes {
            className
            hasButton
        }
    }
`;